var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcelFileIcon2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 252,
    viewBox: "0 0 252 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 132.812,
    y: 30.6484,
    width: 112.378,
    height: 181.622,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.252 22.33H149.698V0.992188L0.851562 23.9659V225.339L149.698 250.977V219.35H240.252C242.994 219.489 245.68 218.536 247.722 216.7C249.764 214.864 250.996 212.294 251.149 209.552V32.1184C250.994 29.3782 249.761 26.8106 247.719 24.9766C245.678 23.1425 242.993 22.191 240.252 22.33ZM241.682 211.179H149.394L149.242 194.293H171.474V174.627H149.072L148.965 163.006H171.474V143.34H148.795L148.688 131.719H171.474V112.053H148.616V100.432H171.474V80.7655H148.616V69.1446H171.474V49.4784H148.616V31.6H241.682V211.179Z",
    fill: "#20744A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M222.644 49.4609H184V69.1272H222.644V49.4609Z",
    fill: "#20744A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M222.644 80.7422H184V100.408H222.644V80.7422Z",
    fill: "#20744A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M222.644 112.031H184V131.697H222.644V112.031Z",
    fill: "#20744A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M222.644 143.32H184V162.987H222.644V143.32Z",
    fill: "#20744A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M222.644 174.609H184V194.276H222.644V174.609Z",
    fill: "#20744A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.719 78.3792L58.9025 77.2797L70.9615 110.435L85.2106 75.912L104.394 74.8125L81.0985 121.886L104.394 169.076L84.111 167.709L70.4162 131.737L56.7124 166.341L38.0742 164.696L59.7249 123.013L39.719 78.3792Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelFileIcon2);
export default __webpack_public_path__ + "static/media/ExcelFileIcon2.77b8ac9fa672f9254276a79948d452dd.svg";
export { ForwardRef as ReactComponent };